import { FieldLabel, TextInput } from '../../components/Primitives.jsx';
import { Segmented } from '../StepInspector.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';

export function ClassifyInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Input column</FieldLabel>
      <ColSelect value={c.column} onChange={(v) => u({ column: v })} />
      <FieldLabel>Strategy</FieldLabel>
      <Segmented value={c.strategy || 'rules'} onChange={(v) => u({ strategy: v })}
        options={[
          { value: 'rules', label: 'Rules' },
          { value: 'ml', label: 'ML model' },
          { value: 'llm', label: 'Claude' },
        ]} />
      <FieldLabel>Classes (comma-separated)</FieldLabel>
      <TextInput mono value={c.classes || 'enterprise, growth, starter'}
        onChange={(v) => u({ classes: v })} />
      <FieldLabel>Output column</FieldLabel>
      <TextInput mono value={c.target ?? 'class'} onChange={(v) => u({ target: v })} />
    </div>
  );
}
